import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod/v4";

export const duplicateShipments = {
  name: "duplicateShipments" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    lineItemExternalIdsToInclude: z.array(z.string()).optional(),
  }),
  output: z.object({ newGroups: z.array(FulfillmentGroupDataSchema) }),
};
